import React from "react";

export function DesktopCheckedIllustration({
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M114 26H14C11.7909 26 10 27.7909 10 30V98C10 100.209 11.7909 102 14 102H114C116.209 102 118 100.209 118 98V30C118 27.7909 116.209 26 114 26Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.5" cy="32.5" r="1.5" fill="currentColor" />
      <circle cx="21.9287" cy="32.5" r="1.5" fill="currentColor" />
      <circle cx="27.3572" cy="32.5" r="1.5" fill="currentColor" />
      <rect
        x="48"
        y="48"
        width="32"
        height="32"
        rx="2.71429"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55 64.4118L61.6087 71L74 57"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
